import { useState } from 'react'

const DEFAULT_FAQS = [
    {
        question: 'How is this different from EDDM (every door direct mail)?',
        answer: "EDDM mails every address on a carrier route. That's useful for basic awareness, but it ignores who lives in the home and whether the property fits your ideal pest control customer. We target by geography, homeowner and property data, home value, new movers, and the neighborhoods around your existing service routes.",
    },
    {
        question: 'Can you help us time campaigns around pest season?',
        answer: 'Yes. Seasonality is one of the clearest use cases for pest control direct mail. We help you plan drops ahead of mosquito, ant, termite swarm, and rodent season, and prioritize which territories should get mail first.',
    },
    {
        question: 'How fast can you get mail out?',
        answer: 'We offer 2-business-day production for most formats once creative and lists are approved. Standard turnaround is 5-7 business days. Seasonal campaigns can move faster when timing matters.',
    },
    {
        question: "What's the minimum spend to get started?",
        answer: "There's no fixed minimum, but this is built for recurring campaigns rather than one-off print orders. Most pest control clients run programs in the $3,500 to $15,000 monthly range depending on market size, campaign volume, and growth goals. If you only need the cheapest postcard order, we're probably not the right fit.",
    },
]

function PlusIcon({ className }) {
    return (
        <svg
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round">
            <line x1="12" y1="5" x2="12" y2="19" />
            <line x1="5" y1="12" x2="19" y2="12" />
        </svg>
    )
}

export default function FAQ({
    eyebrow = 'Frequently asked',
    title = 'Questions pest control companies ask first.',
    faqs = DEFAULT_FAQS,
}) {
    const [openIndex, setOpenIndex] = useState(null)

    return (
        <section className="bg-white">
            <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12 lg:py-16">
                <div className="flex flex-col gap-4 max-w-3xl mb-10">
                    <span className="text-secondary text-xs uppercase tracking-widest font-semibold">
                        {eyebrow}
                    </span>
                    <h2
                        className="text-[#3F454F] tracking-tight text-3xl md:text-[44px] font-bold"
                        style={{ lineHeight: 1.05 }}>
                        {title}
                    </h2>
                </div>

                <div className="flex flex-col gap-3">
                    {faqs.map((faq, i) => (
                        <div
                            key={i}
                            className="flex flex-col bg-white rounded-2xl border border-secondary/30">
                            <button
                                type="button"
                                onClick={() =>
                                    setOpenIndex(openIndex === i ? null : i)
                                }
                                className="cursor-pointer flex flex-row items-center justify-between gap-4 px-6 py-5 text-left w-full hover:bg-secondary/[0.03] transition-colors rounded-2xl">
                                <span
                                    className="text-[#3F454F] font-semibold text-lg"
                                    style={{ lineHeight: '28px' }}>
                                    {faq.question}
                                </span>
                                <div className="w-8 h-8 shrink-0 rounded-full bg-secondary/10 flex items-center justify-center">
                                    <PlusIcon
                                        className={`w-4 h-4 text-secondary transition-transform duration-200 ${
                                            openIndex === i ? 'rotate-45' : ''
                                        }`}
                                    />
                                </div>
                            </button>
                            <div
                                className="overflow-hidden transition-all duration-300"
                                style={{
                                    maxHeight: openIndex === i ? '500px' : '0',
                                    opacity: openIndex === i ? 1 : 0,
                                }}>
                                <div
                                    className="px-6 pb-6 text-[#3F454F]/70 text-lg"
                                    style={{ lineHeight: '28px' }}>
                                    {faq.answer}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}
